<i18n lang="yaml">
  ru:
    ActionSidebarRedirectTitle: "Клиент будет переходить в"
  en:
    ActionSidebarRedirectTitle: "The client will go to"
</i18n>

<template>
  <PWAsideBodyItem
    :title="$t('ActionSidebarRedirectTitle')"
  >
    <PWSelect
      v-model="computedValue"
      :placeholder="$t('messenger')"
      :options="[
        {
          label: 'WhatsApp',
          value: 'whatsapp',
        },
        {
          label: 'Telegram',
          value: 'telegram',
        },
        {
          label: `WhatsApp ${$t('and')} Telegram`,
          value: 'whatsapp-and-telegram',
        },
      ]"
    />
  </PWAsideBodyItem>
</template>

<script>
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import PWSelect from '@/components/_ui/PWSelect.vue'

const MESSENGERS = [
  'whatsapp',
  'telegram',
  'whatsapp-and-telegram'
]

export default {
  components: {
    PWAsideBodyItem,
    PWSelect
  },
  props: {
    value: {
      type: String,
      default: MESSENGERS[0],
      validator: s => MESSENGERS.includes(s)
    }
  },
  computed: {
    computedValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  }
}
</script>
